import { useSearchParams } from 'react-router-dom';
import MmlTileStats from './MmlTileStats';
import ApiRequestStats from './ApiRequestStats';

const TABS = [
  { key: 'mml', label: 'MML Kartat' },
  { key: 'api', label: 'API-pyynnöt' },
];

export default function AdminDashboard() {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get('tab') || 'mml';

  function setTab(key) {
    setSearchParams(prev => {
      const next = new URLSearchParams(prev);
      next.set('tab', key);
      return next;
    }, { replace: true });
  }

  return (
    <div className="container-fluid py-4" style={{ maxWidth: 1100 }}>
      <h2 className="fw-bold mb-1">Admin</h2>
      <p className="text-muted small mb-4">Seuranta ja tilastot</p>

      <ul className="nav nav-tabs mb-4">
        {TABS.map(t => (
          <li key={t.key} className="nav-item">
            <button
              className={`nav-link ${tab === t.key ? 'active' : ''}`}
              onClick={() => setTab(t.key)}
            >
              {t.label}
            </button>
          </li>
        ))}
      </ul>

      {tab === 'mml' && <MmlTileStats embedded />}
      {tab === 'api' && <ApiRequestStats />}
    </div>
  );
}
